import { render, staticRenderFns } from "./TitleList.vue?vue&type=template&id=9ab6f230&scoped=true&"
import script from "./TitleList.vue?vue&type=script&lang=ts&"
export * from "./TitleList.vue?vue&type=script&lang=ts&"
import style0 from "./TitleList.vue?vue&type=style&index=0&id=9ab6f230&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab6f230",
  null
  
)

export default component.exports